import React from 'react';
import {Link} from 'react-router-dom';
import spirit from 'spiritjs';

import {Image} from './Image';
import {Comment} from './Comment';
import {Ava} from './Ava';
import DataPages from './API_Feedbacks';
import {ButtonButton} from './ButtonButton';
import Star from './Star';


var StyleWhite = {
  color: 'white'
};

export class __Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      autoPlay: true
    };
  }

  componentDidMount() {
    spirit.loadAnimation({ path: './animation/ava.json' });
  }

  scrollDown = () => {
    var smoothScroll = require('smoothscroll');
    var exampleDestination = document.querySelector('.decor-line');
    smoothScroll(exampleDestination)
  }

  render() {
    return (
      <div className="content main fading">

        <div className="header">
          <div className="header-image-top-push"></div>
          <div>
            <div className="header-title">Because handmade is Love!</div>
            <div className="header-title-sub">and Love is all you need</div>
          </div>
          <div className="scroll-sign" onClick={this.scrollDown}></div>
          <div className="decor-line">
            <div className="color1"></div>
            <div className="color2"></div>
            <div className="color3"></div>
            <div className="color4"></div>
            <div className="color5"></div>
            <div className="color6"></div>
          </div>
        </div>

        <div className="section section-intro">
          <h1>Quiet Books</h1>
          <p className="subtitle">I was trying very hard to find some information about the history of Quiet Books, but it was of no effect.<br></br>I don't know who was the first that have got an idea to make this soft books for children, but I think this person is a genius.
          </p>
          <p className="subtitle">This sensory books influence positive to the <b>fine motor skills development, gumption, spatial imagination, logical thinking, attention, mathematical and creative skills, diligence and have positive effect on the development of speech</b>. All the pages can be selected or designed to have en educative effect, when a child learns numbers and count, letters, about animal life and so on.
          </p>
        </div>

        <div className="section section--fixed">
          <div className="block-w-images">
            <Image number="1" angle="8" distance="-1500" tp="cov" type="cover" id="Fly" spiritId="Fly" />
            <Image number="2" angle="-8" distance="-1000" tp="cov" type="cover" id="Platon" spiritId="Platon" />
            <Image number="3" angle="8" distance="-500" tp="cov" type="cover" id="McBat" spiritId="McBat" />
          </div>
          <div className="block-w-title">Books
            <p className="block-w-title__text">All books are 100% handmade with a carefully picked fabric and accessories. Sewed with double stitches to make it more durable.</p>
            {/* <ButtonButton idNumber="1" type="Books" /> */}
          </div>
        </div>

        <div className="section section--fixed reversed">
          <div className="block-w-title">Covers
            <p className="block-w-title__text">Design of a cover can be really personal for the child, e.g. with the child's name on it or cute character, etc.</p>
            <ButtonButton align="right" buttonText="Click the button to see list of all" buttonLink="Covers" noref="no" idNumber="1" />
          </div>
          <div className="block-w-images">
            <Image number="3" angle="8" distance="1500" tp="cov" type="cover" id="Owlenko" spiritId="Owlenko" />
            <Image number="2" angle="-8" distance="1000" tp="cov" type="cover" id="Giradlo" spiritId="Giradlo" />
            <Image number="1" angle="8" distance="500" tp="cov" type="cover" id="Ryboolba" spiritId="Ryboolba" />
          </div>
        </div>

        <div className="section section--fixed">
          <div className="block-w-images">
            <Image number="1" angle="8" distance="-1500" tp="cov" type="page" id="Space" spiritId="Space" />
            <Image number="2" angle="-8" distance="-1000" tp="cov" type="page" id="Croco" spiritId="Croco" />
            <Image number="3" angle="8" distance="-500" tp="cov" type="page" id="Leon" spiritId="Leon" />
          </div>
          <div className="block-w-title">Pages
            <p className="block-w-title__text">Your book can consist of 4-12 pages to your choice and it might have one theme (food, animals, count, sea, transport, etc) or mix of different.</p>
            <ButtonButton align="right" buttonText="Click the button to see list of all" buttonLink="Pages" noref="no" idNumber="2" />
          </div>
        </div>

        <div className="section section-about">
          <span id="wavy-back"></span>
          <div className="salut">
            <Link to="/About">
              <Ava />
            </Link>
            <div className="salut-text">
              <span>Salut!</span>
              <Star />
              <p>My name is Olesia Lozovska. I'm one of those crazy mums that want to do something special for their children, that is how BeBiBoo started. I was truly inspired by my beautiful son, sewing the first book and he continues inspire me every day. <Link to="/About"><b style= { StyleWhite } >Read more ...</b></Link></p>
            </div>
          </div>
        </div>

        <div className="section section-comments">
          <div className="section-comments__title">Happy owners</div>
          <div className="section-comments__comments">
            {
              DataPages.all().map(p => (
                  <Comment
                    key={p.number}
                    name={p.name}
                    lang={p.lang}
                    eng={p.eng}
                    other={p.other}
                    img={p.img}
                    location={p.location} />
                )
              )
            }
          </div>
        </div>

        <div className="section section-contact">
          <div className="button">
            <Link to="/Contact"><div className="button">Send message</div></Link>
          </div>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/__Home.js